import React, { useEffect, useState } from "react";
import "./../../index.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import * as api from "../../api/api";
import * as c from "../../const";
import Body from "../body/body";
import { Link } from "react-router-dom";
import * as moment from "moment";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialImageData = {
  id: "",
  image: "",
  title_1: "",
  title_2: "",
  title_3: "",
  created_at: "",
  updated_at: "",
};

const title = {
  id: 0,
  title: "title1",
};

export default function CarouselImage() {
  const classes = useStyles();
  const [imageData, setImageData] = useState(initialImageData);
  const [title1, setTitle1] = useState(title);

  const [heading, setHeading] = useState("");
  // const [title3, setTitle3] = useState(title);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    sliderImage();
    newsApi();
  }, []);

  const sliderImage = async () => {
    try {
      let response = await api.slider();
      setImageData(response);
    } catch (e) {
      console.log(e);
    }
  };

  const newsApi = async () => {
    try {
      let response = await api.headline();
      console.log("response", response);
      setHeading(response);
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
  };

  const CustomDot = ({ onMove, index, onClick, active }) => {
    return active ? (
      <div
        onClick={() => {
          onClick();
        }}
        style={{
          margin: 5,
          marginBottom: 50,
          width: "15px",
          height: "5px",
          backgroundColor: "white",
        }}
      ></div>
    ) : (
      <div
        onClick={() => {
          onClick();
        }}
        style={{
          margin: 5,
          marginBottom: 50,
          width: "15px",
          height: "5px",
          backgroundColor: "#0d2da6",
        }}
      ></div>
    );
  };

  const stop = () => {
    // document.getElementById("mymarquee").marquee.onMouseOver.stop();
    // console.log("called");
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          // paddingBottom: "30px",
          position: "relative",
        }}
      >
        {/* <Carousel
          additionalTransfrom={0}
          arrows={false}
          autoPlay
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          customDot={<CustomDot />}
          // customTransition="all 2s linear"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1024,
              },
              items: 1,
            },
            mobile: {
              breakpoint: {
                max: 464,
                min: 0,
              },
              items: 1,
            },
            tablet: {
              breakpoint: {
                max: 1024,
                min: 464,
              },
              items: 1,
            },
          }}
          showDots
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {Object.keys(imageData).map((index, key) => {
            const url = c.URL;
            let src = `${url}/${imageData[index].image}`;
            return (
              <div key={key}>
                <img
                  className="media-img card-img-top"
                  style={{
                    height: "320px",
                    objectFit: "cover",
                    objectPosition: "100% 60%",
                  }}
                  src={src}
                  alt="Slider1"
                />
              </div>
            );
          })}
        </Carousel> */}

        {/* <div className="marqueeDiv" style={{ overflowY: "scroll" }}>
          <div
            style={{
              padding: "10px",
              color: "white",
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            Headlines
          </div>
          <marquee
            direction="up"
            id="mymarquee"
            className="myMarquee"
            onMouseOver={() => document.getElementById("mymarquee").stop()}
            onMouseOut={() => document.getElementById("mymarquee").start()}
          >
            {Object.keys(heading).map((i) => {
              const title = heading[i].title;
              const id = heading[i].id;
              return (
                // <Marquee
                //   speed={2} // Speed of the marquee (Optional)
                // >
                <div
                  style={{
                    borderBottom: "1px dashed white",
                    padding: "10px 0",
                    borderWidth: "20%",
                  }}
                  key={i}
                >
                  <Link
                    exact
                    to={"/blog/" + id}
                    params={{ testvalue: "hello" }}
                  >
                    <p className="carouselCaption">{title}</p>
                  </Link>
                </div>
                // </Marquee>
              );
            })}
          </marquee>

          <Link
            to={{
              pathname: "/results",
              state: {
                data: {
                  category_id: 1,
                },
              },
            }}
          >
            <button className="headlineButton more-btn hvr-shutter-out-horizontal border-0 ml-2">
              More Headline
            </button>
          </Link>
        </div> */}
      </div>
      <Body />

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </>
  );
}
